import { useCallback } from 'react';
import { useFirebaseAuth } from './useFirebaseAuth';

export const useSignOutFirebase = (): (() => Promise<void>) => {
  const firebaseAuth = useFirebaseAuth();
  return useCallback(async () => {
    return await firebaseAuth.signOut();
  }, [firebaseAuth]);
};
